import React, { useState } from 'react';
import { RiMenu3Line, RiCloseLine } from 'react-icons/ri';
import logo from '../../logo.svg';
import './navbar.css';

const Navbar = () => {
  const [toggleMenu, setToggleMenu] = useState(false);

  return (
    <div className="gpt3__navbar">
      <div className="gpt3__navbar-links">
        <div className="gpt3__navbar-links_logo">
          <img src={logo} />
        </div>
        <div className="gpt3__navbar-links_container">
          <p><a href="#home">Home</a></p>
          <p><a href="#wquantcraft">What is QuantCraft?</a></p>
          {/* <p><a href="#possibility">Tutorials</a></p>
          <p><a href="#possibility">Levels</a></p>
          <p><a href="#possibility">Gate Visualizations</a></p>
          <p><a href="#possibility">Impact</a></p> */}
        </div>
      </div>
      <div className="gpt3__navbar-sign">
      <a href='https://www.linkedin.com/in/sarthak-dhawan-5796901ab/' target={'_blank'}><button type="button">About Us</button></a>
      </div>
      <div className="gpt3__navbar-menu">
        {toggleMenu
          ? <RiCloseLine color="#fff" size={27} onClick={() => setToggleMenu(false)} />
          : <RiMenu3Line color="#fff" size={27} onClick={() => setToggleMenu(true)} />}
        {toggleMenu && (
        <div className="gpt3__navbar-menu_container scale-up-center">
          <div className="gpt3__navbar-menu_container-links">
            <p><a href="#home">Home</a></p>
            <p><a href="#wquantcraft">What is QuantCraft?</a></p>
            {/* <p><a href="#possibility">Tutorials</a></p>
            <p><a href="#possibility">Levels</a></p>
            <p><a href="#possibility">Gate Visualizations</a></p>
            <p><a href="#possibility">Impact</a></p> */}
          </div>
          <div className="gpt3__navbar-menu_container-links-sign">
            <a href='https://www.linkedin.com/in/sarthak-dhawan-5796901ab/' target={'_blank'}><button type="button">About Us</button></a>
          </div>
        </div>
        )}
      </div>
    </div>
  );
};

export default Navbar;
